import { rest } from '@updater/redux-http-request';

// HACK: To remove the item_definitions and item_definition_phases when
// reading site_configs. We need to do this since there is no way, as of
// right now, to tie item_definitions/phases to a particular move. So, we
// will just blow out any item_definitions/phases whenever we make a call
// to get the site-config. This defeats the purpose of caching, but it is
// what it is at the moment.
export function decorateJsonApiReducerForSiteConfig(originalReducer) {
  return (state, action) => {
    if (rest.matchers.isRequestRestResource('site_config')(action)) {
      return {
        resources: {
          ...state.resources,
          item_definitions: {},
          item_definition_phases: {},
        },
      };
    } else {
      return originalReducer(state, action);
    }
  };
}
